import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="flex items-center justify-between h-16 md:h-20 px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
          <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center shrink-0">
            <i className="ri-alarm-warning-line text-xl text-background-50"></i>
          </span>
          <h1 className="font-heading text-lg md:text-xl font-bold text-foreground-950 whitespace-nowrap tracking-tight">
            黑料社区
          </h1>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={link.href}
              className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#submit"
            className="hidden sm:flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-fill text-base"></i>
            <span>匿名投稿</span>
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="px-3 py-2.5 rounded-md text-sm text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#submit"
            onClick={() => setMenuOpen(false)}
            className="mt-2 flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
          >
            <i className="ri-send-plane-fill"></i>
            <span>匿名投稿</span>
          </a>
        </div>
      )}
    </header>
  );
}